import axios from 'axios'
import { HABILITAR_VENDAS_EM_LOTE_NO_SITE } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function habilitarVendasEmLoteNoSite (parametros) {
  const url = `${URL}/itinerario/habilitar-vendas-em-lote-no-site`;
  return dispatch => axios.post(url, parametros, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: HABILITAR_VENDAS_EM_LOTE_NO_SITE,
        payload: response
      })
  );
}
